import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {signOutUser} from 'common/authThunkActions';
import LightBoxModal from 'components/LightboxModal';
import {useHistory} from "react-router-dom";

const Logout = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isSignedIn } = useSelector(state => state.currentUser);

  useEffect(() => {
    dispatch(signOutUser());
  }, []);

  useEffect(() => {
    if (!isSignedIn) {
      history.replace("/signin");
    }
  }, [isSignedIn]);

  return (
    <LightBoxModal show />
  );
};

export default Logout;
